/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiSegmentFeature {
    SCREENING_FLOWS = 'SCREENING_FLOWS',
    AUTOMATIC_RE_SCREENING = 'AUTOMATIC_RE_SCREENING',
    SCENARIOS = 'SCENARIOS',
    LIBRARY_SCENARIOS = 'LIBRARY_SCENARIOS'
}


export function instanceOfInternalApiSegmentFeature(value: any): boolean {
    for (const key in InternalApiSegmentFeature) {
        if (Object.prototype.hasOwnProperty.call(InternalApiSegmentFeature, key)) {
            if (InternalApiSegmentFeature[key as keyof typeof InternalApiSegmentFeature] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiSegmentFeatureFromJSON(json: any): InternalApiSegmentFeature {
    return InternalApiSegmentFeatureFromJSONTyped(json, false);
}

export function InternalApiSegmentFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSegmentFeature {
    return json as InternalApiSegmentFeature;
}

export function InternalApiSegmentFeatureToJSON(value?: InternalApiSegmentFeature | null): any {
    return value as any;
}

export function InternalApiSegmentFeatureToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiSegmentFeature {
    return value as InternalApiSegmentFeature;
}

